export default "__VITE_ASSET__bc7737be__"